import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

export const GLOBAL_APP_MENU_ITEMS = [
  { href: "/stock", label: "股票行情 (stock)" },
  { href: "/wyckoff", label: "威科夫实验室 (wyckoff)" },
  { href: "/news", label: "市场大盘 (news)" },
  { href: "/quant", label: "智能选股 (quant)" },
  { href: "/ops", label: "运维看板 (ops)" },
  { href: "/dataflow", label: "数据引擎 (dataflow)" },
] as const;

export function GlobalAppMenu({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      if (!rootRef.current) {
        return;
      }
      if (rootRef.current.contains(event.target as Node)) {
        return;
      }
      setOpen(false);
    };
    window.addEventListener("pointerdown", onPointerDown);
    return () => window.removeEventListener("pointerdown", onPointerDown);
  }, []);

  return (
    <div className={`relative z-[80] ${className || ""}`} ref={rootRef}>
      <button
        className="inline-flex h-8 items-center gap-1 rounded-md border border-[var(--border)] bg-[#1a1e25] px-2 text-xs font-semibold text-slate-200 hover:bg-white/5"
        onClick={() => setOpen((prev) => !prev)}
      >
        LisaQ
        <ChevronDown className={`size-3.5 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open ? (
        <div className="absolute left-0 top-9 z-[90] w-44 rounded-md border border-[var(--border-strong)] bg-[#0f1217] p-1 shadow-2xl">
          {GLOBAL_APP_MENU_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="block rounded px-2 py-1.5 text-xs text-slate-200 hover:bg-white/8"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
}
